import { render, staticRenderFns } from "./BuildingUserForm.vue?vue&type=template&id=7bf0546c"
import script from "./BuildingUserForm.vue?vue&type=script&lang=js"
export * from "./BuildingUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports